module.exports = __webpack_public_path__ + "img/zhiya.5eac9dbb.png";